"use client";

import { SafeHydrate } from "@/SafeHydrate";
import React from "react";
import { Avatar, AvatarFallback } from "@/components/ui/avatar";
import { Badge } from "@/components/ui/badge";
import { Card, CardContent, CardHeader } from "@/components/ui/card";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const partners = [{
  initials: "RC",
  name: "Ricardo Castanheora",
  role: "DIRETOR DE FRANQUIA",
  bio: "Especialista em implementação Linx E-millennium com mais de 15 anos de experiência em otimização de processos e gestão varejista.",
  badge: "LINX EXPERT"
}, {
  initials: "BD",
  name: "Bruna Deruci",
  role: "Estrategista de Negócios",
  bio: "Auxilia empresas na transição digital utilizando soluções robustas de gestão, integração de canais e estratégias de e-commerce.",
  badge: "BUSINESS STRATEGY"
}, {
  initials: "RM",
  name: "Renato Mansano",
  role: "Suporte Técnico Especializado",
  bio: "Lidera a equipe de suporte técnico garantindo a continuidade, segurança e alta performance das operações críticas dos nossos clientes.",
  badge: "TECH SUPPORT"
}];
export default function TheThreePartners() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll();
  return <section data-section-id="133732" id="equipe-de-consultores" className="bg-background py-16 md:py-24 relative overflow-hidden">
      <div className="container mx-auto px-4 relative z-10">
        <div className="text-center mb-16">
          <h2 className="text-white mb-4">Equipe de Consultores</h2>
          <p className="text-muted-foreground lead max-w-2xl mx-auto">
            Especialistas certificados prontos para impulsionar a gestão e os resultados da sua empresa com tecnologia Linx.
          </p>
        </div>

        <div ref={ref} className={`grid grid-cols-1 md:grid-cols-3 gap-8 transition-all duration-1000 ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-12"}`}>
          {partners.map((partner, i) => <div data-index={i} key={i} className="h-full">
              <Card className="h-full bg-background/70 backdrop-blur-[12px] border border-border transition-all duration-300 hover:-translate-y-1 hover:shadow-[0_10px_30px_rgba(255,0,110,0.2)] group overflow-hidden rounded-[12px] flex flex-col">
                <CardHeader className="flex flex-col items-center text-center pt-10 pb-4 relative z-10">
                  <div className="relative mb-6">
                    <div className="absolute inset-0 rounded-full bg-primary blur-[15px] opacity-40 group-hover:opacity-70 transition-opacity duration-500"></div>
                    <SafeHydrate><Avatar className="size-24 border-2 border-primary relative z-10">
                      <AvatarFallback className="bg-muted text-white font-sans text-2xl font-bold">
                        {partner.initials}
                      </AvatarFallback>
                    </Avatar></SafeHydrate>
                  </div>
                  <h3 className="font-sans text-2xl text-white mb-1">
                    {partner.name}
                  </h3>
                  <p className="font-sans text-sm uppercase tracking-widest text-muted-foreground">
                    {partner.role}
                  </p>
                </CardHeader>
                <CardContent className="flex flex-col items-center text-center pb-10 relative z-10 flex-grow justify-between">
                  <p className="font-sans text-base text-white/80 mb-8 leading-relaxed">
                    {partner.bio}
                  </p>
                  <Badge variant="default" className="bg-primary text-white hover:bg-primary/90 border-none px-4 py-1.5 text-xs font-bold tracking-wider">
                    {partner.badge}
                  </Badge>
                </CardContent>
              </Card>
            </div>)}
        </div>
      </div>
    </section>;
}